module.exports = __webpack_public_path__ + "files/2537e93353a52ef9eb7b6e6804f540b4.svg";